import moment from 'moment';
import { internalDateFormat } from '../constants';
export const convertDateToInternalFormat = (dates) => {
    const date = dates[0];
    const result = date
        ? moment({
            date: date.getDate(),
            hours: date.getHours(),
            minutes: date.getMinutes(),
            months: date.getMonth(),
            years: date.getFullYear(),
        }).format(internalDateFormat.moment)
        : '';
    return result;
};
//# sourceMappingURL=convertDateToInternalFormat.js.map